import { createRoot, Root } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import App from './App';
import React from 'react';

const container: HTMLElement = document.getElementById('root') as HTMLElement;
const root: Root = createRoot(container!);

root.render(
//	<React.StrictMode>
		<App/>
//	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();